import { ChatBubbleOutline, Edit } from "@mui/icons-material";
import { Fragment } from "react";
import { textColors } from "@/shared/forms/ColorPicker";
import ProjectNoteDialog from "./ProjectNoteDialog";
import { ProjectNote } from "../Project";
import { useCustomDrag } from "./CustomDragContext";

type NoteSpan = {
  colStart: number;
  colEnd: number;
  row: number;
  isBegin: boolean;
  isEnd: boolean;
};

export default function ProjectNoteBar({ note, span, rowStart, writeable, onSave }: { note: ProjectNote; span: NoteSpan; rowStart: number; writeable: boolean; onSave: (note: ProjectNote) => void }) {
  const { element: start, isDragging: isDraggingStart } = useCustomDrag({ date: note.startDate, item: { id: `${note.clientId}-start`, type: "note_start", note } });
  const { element: end, isDragging: isDraggingEnd } = useCustomDrag({ date: note.endDate, item: { id: `${note.clientId}-end`, type: "note_end", note } });
  const { element: move, isDragging: isDraggingMove } = useCustomDrag({ date: note.startDate, item: { id: `${note.clientId}-move`, type: "note_move", note } });
  return <Fragment>
    <div className={`hw_phase hw_note${span.isBegin ? " isBegin" : ""}${span.isEnd ? " isEnd" : ""}`} style={{
      backgroundColor: note.color,
      color: textColors[note.color] ?? "#111",
      gridColumnStart: String(span.colStart),
      gridColumnEnd: String(span.colEnd + 1),
      gridRow: rowStart + span.row,
    }}>
      {span.isBegin && writeable ? <div className={`hw_phase_handle_start${isDraggingStart ? " dragging" : ""}`} {...start} /> : null}
      <div className={`hw_phase_name hw_note_move${isDraggingMove ? " dragging" : ""}`} {...(writeable ? move : {})}><div className="hw_phase_namepart">{note.title}</div>{note.description.trim() ? <ChatBubbleOutline fontSize="inherit" /> : null}</div>
      {writeable ? <ProjectNoteDialog note={note} onSave={onSave} opener={<div className="hw_job_create_button hw_note_edit" style={{ backgroundColor: `color-mix(in srgb, ${note.color} 50%, #FFFFFF 100%)`, color: "#111" }}><Edit fontSize="small" /></div>} /> : null}
      {span.isEnd && writeable ? <div className={`hw_phase_handle_end${isDraggingEnd ? " dragging" : ""}`} {...end} /> : null}
    </div>
    <div
      className="hw_job_placeholder"
      style={{
        gridColumnStart: String(span.colStart),
        gridColumnEnd: String(span.colEnd + 1),
        gridRowStart: String(rowStart + span.row + 2),
        gridRowEnd: String(rowStart + span.row + 2),
      }}
    />
  </Fragment>;
}
